__turbopack_context__.v({
  "className": "geist_mono_6ab5d9d-module__TMkHfG__className",
  "variable": "geist_mono_6ab5d9d-module__TMkHfG__variable",
});
